<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: (items.highlightArea.top + isMsgTop) + 'px'
              }"></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
              }"></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content" v-html="items.content"></div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList flex">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
                <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="items.btnList.includes('next')" @click="nextStep(null)" class="gj-pointer completeBtn">下一步</div>
              <div v-if="items.btnList.includes('know')" @click="nextTask" class="gj-pointer knowBtn">我知道了</div>
              <div v-if="items.btnList.includes('complete')" @click="completeTask" class="gj-pointer completeBtn">完成任务</div>
              <template v-if="items.btnList.includes('continue')">
                <div @click="setUserGuideState" class="gj-pointer knowBtn gj-mr4">继续添加</div>
                <div @click="nextTask" class="gj-pointer completeBtn">下一步</div>
              </template>
            </div>
          </div>
          <div v-if="items.guideDirection === 'left'" class="user-guide-point" :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
          <div v-if="items.guideDirection === 'top'" class="user-guide-point" :style="{ width: items.guideWidth + 'px', transform: 'rotate(90deg)', top: `-${items.guideWidth/2}px`, left: '50%', marginLeft: `-${items.guideWidth/2}px` }">
            <div class="user-guider-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal";
import {userGuideMixin} from "@/minxins";
import {mapGetters} from "vuex";
export default {
  name: "new-user-guide",
  props: {
    guideRef: {
      value: null
    }
  },
  mixins: [userGuideMixin],
  inject: ["changeTab"],
  data() {
    return {
      bootSteps: 0,
      data: [],
      isMsgTop: 0,
      clientWidth: 0,
      subtractHeight: 0,
      addWidth: 0,
      taskItem: null
    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.clientWidth = document.body.clientWidth;
    this.initData();
    this.bootSteps = 1;
    this.changeTab('base');
    this.taskItem = this.userGuideTaskItem;
  },
  methods: {
    initData() {
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical';
      const subtractHeight =  isNavHorizontal ? 0 : 40;
      const addWidth =  isNavHorizontal ? 0 : 60;
      this.subtractHeight = subtractHeight;
      this.addWidth = addWidth;
      this.data = [
        {
          id: 1,
          class: "user-guide-one",
          type: 'default',
          needMask: true,
          highlightArea: {
            width: 60,
            height: 34,
            top: 181 - subtractHeight,
            left: 30 + addWidth,
          },
          guideArea: {
            top: 158 - subtractHeight,
            left: 146 + addWidth,
          },
          guideDirection: 'left',
          guideWidth: 60,
          content: "您可以通过【添加】按钮逐个添加<br/>如果没有维护头程物流，则无法在系统完成发货单流程哦~",
          btnList: ['video'],
        },
        {
          id: 2,
          class: "user-guide-two",
          type: 'default',
          needMask: true,
          highlightArea: {
            width: this.clientWidth - 60 - addWidth,
            height: 90,
            top: 181 - subtractHeight,
            left: 30 + addWidth,
          },
          guideArea: {
            top: 300 - subtractHeight,
            left: (this.clientWidth - 402  + addWidth)/2 ,
          },
          guideDirection: 'top',
          guideWidth: 60,
          content: "您可以在此页面查看物流方式的时效~",
          btnList: ['next'],
        },
        {
          id: 3,
          class: "user-guide-three",
          type: 'default',
          needMask: true,
          highlightArea: {
            width: this.clientWidth - 60 - addWidth,
            height: 90,
            top: 230 - subtractHeight,
            left: 30 + addWidth
          },
          guideArea: {
            top: 360 - subtractHeight,
            left: (this.clientWidth - 402  + addWidth)/2 ,
          },
          guideDirection: 'top',
          guideWidth: 60,
          content: "您已添加了物流方式，可以留在此页面继续添加，也可按照教程继续完成其他任务~",
          btnList: ['continue'],
        }
      ]
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep(step = null) {
      if(step) {
        this.bootSteps = step
      } else {
        this.bootSteps++;
      }
      if(this.bootSteps == 3) {
        this.changeTab('base')
      }
      let activeItem = this.data.find(item => item.id === this.bootSteps);
      if(activeItem && activeItem.type === 'menu') {
        this.$store.commit(SET_USER_GUIDE_MENU_PATH, activeItem.path);
      }
    },
    async nextTask() { // 下个任务
      const taskItem = this.taskItem;
      const { finishTaskList, nextTask } = await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode);
      if(!finishTaskList && nextTask) { // 大任务未完成, 且有正常任务链路
        this.jumpToGuidePage(nextTask, () => {
          this.bootSteps = 0;
        })
      } else if(finishTaskList) { // 任务全部完成
        if(taskItem.taskStatus != 'COMPLETED') {
          this.completeTask();
        } else if(nextTask) {
          this.jumpToGuidePage(nextTask, () => {
            this.bootSteps = 0;
          })
        }
      }
    },
    temporarilyClosed() { // 暂时关闭，不退出引导状态
      this.bootSteps = 0;
    },
    completeTask() {
      this.bootSteps = 0;
      this.$emit('closeModal');
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskItem?.taskTypeCode
        }
      })
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>